module.exports = __webpack_public_path__ + "img/Vision_ic.b2a3af77.svg";